import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {getUserProxyByUserId} from '@components/common/base/avatar/use-user-proxy'
import {Table} from './common/table/table'
import {StatisticsRows} from './item/rows'
import {useStatsTimelineStore} from './stats-timeline-store'

export const StatsTimelineTable = observer(() => {
  const [state, store] = useStatsTimelineStore()
  return (
    <>
      {store.events &&
        Object.keys(store.events).length > 0 &&
        state.view === 'table' && (
          <Table>
            <Table.Header>
              <Table.Title className="w-128">
                {Lang.msg.statsTimeline.dateTime}
              </Table.Title>
              <Table.Title className="w-10/12 truncate">
                {Lang.msg.statsTimeline.action}
              </Table.Title>
              <Table.Title className="w-1/5 truncate">
                {Lang.msg.statsTimeline.initiator}
              </Table.Title>
              <Table.Title className="w-1/3 truncate">
                {Lang.msg.statsTimeline.location}
              </Table.Title>
              <Table.Title className="w-1/4 truncate">
                {Lang.msg.statsTimeline.task}
              </Table.Title>
            </Table.Header>
            <Table.Body>
              {Object.keys(store.events)
                .filter(k => getUserProxyByUserId(store.events[+k].user))
                .map(timestamp => (
                  <StatisticsRows
                    key={timestamp}
                    user={getUserProxyByUserId(store.events[+timestamp].user)}
                    event={store.events[+timestamp]}
                    timestamp={+timestamp}
                    restore={store.restore}
                    errors={state.errors}
                    reportError={store.reportError}
                  />
                ))}
            </Table.Body>
          </Table>
        )}
    </>
  )
})
